export const UMPIRE_MASK_PATH =
  'M9 4 Q16 1 23 4 L26 11 24 24 20 29 12 29 8 24 6 11 Z M7 9 L3 8 2 13 3 22 8 23 M25 9 L29 8 30 13 29 22 24 23 M7 11 H25 M7 17 H25 M9 23 H23 M12 4 L11 17 13 29 M20 4 L21 17 19 29'

export const UMPIRE_TROPHY_PATH =
  'M10 4h12v8c0 5-3 8-6 8s-6-3-6-8V4 M10 7H5v4c0 4 3 6 6 6 M22 7h5v4c0 4-3 6-6 6 M16 20v7 M10 28h12'
